import { useState } from 'react'
import {
  Group,
  Panel,
  Separator,
  useDefaultLayout,
  usePanelRef,
} from 'react-resizable-panels'
import MainNav from '../MainNav/MainNav'
import MainDisplay from '../MainDisplay/MainDisplay'
import NavRail from '../NavRail/NavRail'
import './MainLayout.css'

// Reusable body layout for authenticated pages: a resizable, collapsible left
// sidebar (action rail + MainNav) beside a main content region (MainDisplay).
//
// Pass content via `nav` / `display`, rail buttons via `navActions` (top) and
// `navFooter` (bottom, e.g. notifications). Give each page a unique `storageId`
// so its pane sizes persist independently. Size props are percentages (0..100).
function MainLayout({
  storageId = 'main-layout',
  navLocation,
  navSearch,
  nav,
  navActions = [],
  navFooter,
  navDock,
  displayHeader,
  display,
  defaultNavSize = 22,
  minNavSize = 12,
  maxNavSize = 40,
}) {
  const { defaultLayout, onLayoutChanged } = useDefaultLayout({
    id: storageId,
    panelIds: ['nav', 'display'],
    storage: typeof window !== 'undefined' ? window.localStorage : undefined,
  })
  const navPanelRef = usePanelRef()
  const [collapsed, setCollapsed] = useState(false)

  const handleToggleCollapse = () => {
    const panel = navPanelRef.current
    if (!panel) return
    if (panel.isCollapsed()) {
      panel.expand()
    } else {
      panel.collapse()
    }
  }

  return (
    <div className="main-layout">
      <Group
        orientation="horizontal"
        className="main-panelgroup"
        defaultLayout={defaultLayout}
        onLayoutChanged={onLayoutChanged}
      >
        <Panel
          id="nav"
          className="main-panel"
          panelRef={navPanelRef}
          collapsible
          collapsedSize="48px" /* matches --ct-navrail-width so only the rail shows */
          defaultSize={`${defaultNavSize}%`}
          minSize={`${minNavSize}%`}
          maxSize={`${maxNavSize}%`}
          onResize={(size) => setCollapsed(size.inPixels <= 60)}
        >
          <MainNav
            location={navLocation}
            search={navSearch}
            footer={navDock}
            rail={
              <NavRail
                collapsed={collapsed}
                onToggleCollapse={handleToggleCollapse}
                actions={navActions}
                footer={navFooter}
              />
            }
          >
            {nav}
          </MainNav>
        </Panel>

        <Separator className="main-resize-handle" />

        <Panel id="display" className="main-panel" minSize="40%">
          <MainDisplay header={displayHeader}>{display}</MainDisplay>
        </Panel>
      </Group>
    </div>
  )
}

export default MainLayout
